export default __webpack_public_path__ + "static/media/cv.9418002b.pdf";